function renderSinglePageDataTemplate({ singular }: { singular: string }): string {
  return `  const data = await get${singular}()
`
}

function renderSinglePageGeneratedValueTemplate({ singular }: { singular: string }): string {
  return `  const [data, initialSettings] = await Promise.all([
    get${singular}(),
    getSetting()
  ])
`
}

function renderSinglePageImportsTemplate({
  settingsImport,
  singular,
  actionImportPath,
  devModeIntegrationButtonExportName,
  devModeIntegrationButtonImportPath,
  schemaName,
  pageName,
  dataLoad,
  schemaLabel,
  initialSettingsProp
}: {
  settingsImport: string
  singular: string
  actionImportPath: string
  devModeIntegrationButtonExportName: string
  devModeIntegrationButtonImportPath: string
  schemaName: string
  pageName: string
  dataLoad: string
  schemaLabel: string
  initialSettingsProp: string
}): string {
  return `${settingsImport}import { get${singular} } from '@admin/actions/${actionImportPath}'
import { PageHeader } from '@admin/components/shared/page-header'
import { ${devModeIntegrationButtonExportName} } from '${devModeIntegrationButtonImportPath}'
import { ${singular}Form } from './${schemaName}-form'
import React from 'react'

export default async function ${pageName}Page() {
${dataLoad}

  return (
    <React.Fragment>
      <PageHeader
        title="${schemaLabel}"
        actions={<${devModeIntegrationButtonExportName} ${initialSettingsProp} />}
      />
      <main className="mx-auto max-w-5xl w-full p-4">
        <${singular}Form initialData={data} />
      </main>
    </React.Fragment>
  )
}
`
}

export function renderSinglePageRenderer(
  request:
    | { kind: 'renderSinglePageDataTemplate'; props: { singular: string } }
    | { kind: 'renderSinglePageGeneratedValueTemplate'; props: { singular: string } }
    | {
        kind: 'renderSinglePageImportsTemplate'
        props: {
          settingsImport: string
          singular: string
          actionImportPath: string
          devModeIntegrationButtonExportName: string
          devModeIntegrationButtonImportPath: string
          schemaName: string
          pageName: string
          dataLoad: string
          schemaLabel: string
          initialSettingsProp: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderSinglePageDataTemplate':
      return renderSinglePageDataTemplate(request.props)
    case 'renderSinglePageGeneratedValueTemplate':
      return renderSinglePageGeneratedValueTemplate(request.props)
    case 'renderSinglePageImportsTemplate':
      return renderSinglePageImportsTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
